var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 8.90625L104.648 89.0625C106.133 92.0312 105.762 95 103.535 97.9688H10.4648C8.23828 95 7.86719 92.0312 9.35156 89.0625L57 8.90625Z",
    fill: "url(#paint0_linear_27651_4006)",
    stroke: "#B81E1F",
    strokeWidth: 2.22656
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3359 35.625H55.6641C54.1884 35.625 52.9922 36.8212 52.9922 38.2969V68.5781C52.9922 70.0538 54.1884 71.25 55.6641 71.25H58.3359C59.8116 71.25 61.0078 70.0538 61.0078 68.5781V38.2969C61.0078 36.8212 59.8116 35.625 58.3359 35.625Z",
    fill: "#F5E1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86.3906C60.4432 86.3906 63.2344 83.5994 63.2344 80.1562C63.2344 76.7131 60.4432 73.9219 57 73.9219C53.5568 73.9219 50.7656 76.7131 50.7656 80.1562C50.7656 83.5994 53.5568 86.3906 57 86.3906Z",
    fill: "#F5E1D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27651_4006",
    x1: 8.46094,
    y1: 8.90625,
    x2: 8.46094,
    y2: 97.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF605C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62526"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/pageNotFound.ea7f56bef8cf6a1fd4e259d49840e912.svg";
export { ForwardRef as ReactComponent };